import { useEffect, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";
import html2canvas from "html2canvas";
import { Button, Container, Message, MessageHeader } from "semantic-ui-react";
import { useAuth } from "../App";
import QRAliasDialog from "../components/dialog/QRAliasDialog";
import QRDownloadDialog from "../components/dialog/QRDownloadDialog";
import QRContainer from "../components/QRContainer";
import { sizeOptions } from "../utils/qrformat";
import { trackDownloadQREvent, trackPageView } from "../utils/analytics";

const qrCode = new QRCodeStyling({
  width: 300,   //TODO: podla sirky priamo umerne prisposobovat aj sirku 320px a rem na fontSize textov - mozno aj border radius
  height: 300,
  image:
    "qr/logo.png",
  dotsOptions: {
    color: "#000000",
    type: "rounded"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 0
  }
});

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // breakpoint for smartphone
    };

    handleResize(); // init
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export default function QRCodePage() {
  const { user } = useAuth();
  const [openQrAliasDialog, setOpenQrAliasDialog] = useState(false);
  const [openQrDownloadDialog, setOpenQrDownloadDialog] = useState(false);
  const [exportSize, setExportSize] = useState(null);
  const isMobile = useIsMobile();

  const ref = useRef(null);

  const createQrLogo = () => {
    setOpenQrAliasDialog(true);
  }

  const exportLogo = () => {
    setOpenQrDownloadDialog(false);
    html2canvas(document.querySelector("#exportContainer"), { backgroundColor: null, useCORS: true }).then(canvas => {
      const image = canvas.toDataURL("image/png", 1.0);
      const fileName = `KM_${getAlias()}_QR_${exportSize.name}.png`
      downloadImage(image, fileName);
      trackDownloadQREvent();
    });
    setExportSize(null);
  }

  useEffect(() => {
    if (getAlias() != null) {
      const url = "http://kontaktuj.sk/" + user.data.alias
      qrCode.update({
        data: url
      });
      qrCode.append(ref.current);
    }
  }, [user]);

  const downloadImage = (blob, fileName) => {
    const fakeLink = window.document.createElement("a");
    fakeLink.style = "display:none;";
    fakeLink.download = fileName;

    fakeLink.href = blob;

    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);

    fakeLink.remove();
  };

  const getAlias = () => {
    return user?.data?.alias;
  }

  const onDownloadDialogSubmit = (sizeValue) => {
    const size = sizeOptions.find(s => s.value === sizeValue);
    setExportSize(size);
  }

  return (
    <div className="App">
      {getAlias() ? <div id="maincontainer">
        <QRContainer alias={getAlias()} size={isMobile ? 250 : 400} />
        <div style={{ margin: '2rem' }}>
          <Button icon="download" color="yellow" onClick={() => {
            setOpenQrDownloadDialog(true);
          }}>STIAHNUŤ NÁLEPKU</Button>
        </div>
      </div> : <Container>
        <Message warning>
          <MessageHeader>Začíname!</MessageHeader>
          <p>Zatiaľ nemáš k dispozícii alias. Vytvor si ho, aby si mohol dostávať správy a mať vlastnú QR nálepku.</p>
        </Message>
        <div style={{ margin: '2rem' }}>
          <Button icon="download" color="yellow" onClick={createQrLogo}>VYTVORIŤ QR ALIAS</Button>
        </div>
      </Container>}

      <QRAliasDialog
        open={openQrAliasDialog}
        onClose={() => setOpenQrAliasDialog(false)}
      ></QRAliasDialog>

      <QRDownloadDialog
        open={openQrDownloadDialog}
        onSubmit={onDownloadDialogSubmit}
        onClose={() => setOpenQrDownloadDialog(false)}
      ></QRDownloadDialog>

      <QRContainer onReady={exportLogo} exportContainer alias={getAlias()} size={exportSize ? exportSize.pxSize : 100} />
    </div>
  );
}
